<template>
  <div class="profile-container">
    <el-card class="profile-card">
      <div slot="header" class="card-header">
        <span>个人中心</span>
      </div>
      
      <div class="profile-info">
        <el-descriptions title="账号信息" :column="1" border>
          <el-descriptions-item label="用户名">
            {{ username }}
          </el-descriptions-item>
          <el-descriptions-item label="角色">
            管理员
          </el-descriptions-item>
        </el-descriptions>
      </div>

      <el-divider></el-divider>

      <div class="password-section">
        <h3>修改密码</h3>
        <el-form
          :model="passwordForm"
          :rules="passwordRules"
          ref="passwordForm"
          label-width="100px"
          class="password-form">
          <el-form-item label="原密码" prop="oldPassword">
            <el-input
              v-model="passwordForm.oldPassword"
              type="password"
              placeholder="请输入原密码"
              show-password>
            </el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPassword">
            <el-input
              v-model="passwordForm.newPassword"
              type="password"
              placeholder="请输入新密码"
              show-password>
            </el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmPassword">
            <el-input
              v-model="passwordForm.confirmPassword"
              type="password"
              placeholder="请再次输入新密码"
              show-password>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleChangePassword" :loading="loading">
              修改密码
            </el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { changePassword } from '@/api/auth'

export default {
  name: 'Profile',
  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    return {
      username: localStorage.getItem('admin_username') || 'admin',
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordRules: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 5, message: '密码长度不能少于5位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  methods: {
    handleChangePassword() {
      this.$refs.passwordForm.validate(valid => {
        if (valid) {
          this.loading = true
          changePassword({
            username: this.username,
            oldPassword: this.passwordForm.oldPassword,
            newPassword: this.passwordForm.newPassword
          }).then(res => {
            if (res.data.code === 200) {
              this.$message.success('密码修改成功，请重新登录')
              this.resetForm()
              // 清除token，跳转到登录页
              setTimeout(() => {
                localStorage.removeItem('admin_token')
                localStorage.removeItem('admin_username')
                this.$router.push('/login')
              }, 1500)
            } else {
              this.$message.error(res.data.message || '密码修改失败')
            }
          }).catch(() => {
            this.$message.error('密码修改失败')
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    resetForm() {
      this.$refs.passwordForm.resetFields()
    }
  }
}
</script>

<style scoped>
.profile-container {
  padding: 20px;
}

.profile-card {
  max-width: 800px;
  margin: 0 auto;
}

.card-header {
  font-size: 18px;
  font-weight: bold;
}

.profile-info {
  margin-bottom: 20px;
}

.password-section {
  margin-top: 20px;
}

.password-section h3 {
  margin-bottom: 20px;
  color: #333;
}

.password-form {
  max-width: 500px;
}
</style>
